import axios from "axios"
import { withServerCache } from "utils/serverCache"

const getAdvertisement = async () => {
    return withServerCache(
        "advertisements-list",
        async () => {
            const apiUrl = process.env.NEXT_PUBLIC_API_URL_V2
            const res = await axios.get(`${apiUrl}advertisement-groups`)

            if (res.data) {
                return res.data
            }
            throw new Error("Failed to fetch advertisements")
        },
        5 * 60 * 1000 // 5 minutes TTL
    )
}

export default getAdvertisement

